import React, { useState, useContext, useEffect, useRef } from 'react'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import CampaignContext from '@/product/context/campaign/campaignContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
// import EmailEditor from '../../product/components/atoms/EmailEditor'

const TemplateManage = (props) => {
    const campaignContext = useContext(CampaignContext)

    const {
        campaignTemplateAction,
        getCampaignTemplates,
        all_templates,
        responseStatus,
    } = campaignContext

    const data = props.data
    const [isLoading, setIsLoading] = useState(false)
    const [isReload, setReload] = useState()
    const [reloadEditor, setReloadEditor] = useState(false)

    const validationArray = Yup.object({
        // template: Yup.string().required('Required!'),
        title: Yup.string().when('type', {
            is: (type) => type === 'template',
            then: Yup.string().required('Required!'),
            otherwise: Yup.string(),
        }),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            // subject: '',
            type: 'template',
            template: '',
            title: '',
            method: 'email',
            template_advanced: 0,
            template_design: null,
            template_html: null,
            defaultAddition: true,
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: async (values) => {
            let value = values
            console.log('FormikValues', value)
            setIsLoading(true)
            campaignTemplateAction(value, 'CAMPAIGN_TEMPLATE_ACTION')
        },
    })

    const emailTemplate = [
        {
            label: 'Title',
            placeholder: 'Enter Title',
            class: `col-12 ${props.data.status === 'base' ? 'd-none' : ''}`,
            type: 'text',
            shrink: true,
            name: 'title',
        },
        // {
        //     label: 'Subject',
        //     placeholder: 'Enter subject',
        //     class: 'col-12 ',
        //     type: 'text',
        //     shrink: true,
        //     name: 'subject',
        // },
        {
            label: 'Advanced',
            // disabled: formik.values.diffname ? true : false,
            type: 'switch',
            class: `col-sm-6 col-12 mb-3`,
            name: 'template_advanced',
        },
        {
            class: `col-12 ${formik.values.template_advanced ? 'd-none' : ''}`,
            name: 'template',
            type: 'ckeditor',
        },
        {
            class: `col-12 ${formik.values.template_advanced ? '' : 'd-none'}`,
            // type: 'ckeditor',
            type: 'advancedEditor',
            reload: reloadEditor,
            name: 'template_design',
            htmlName: 'template_html',
        },
    ]

    const resetFrom = () => {
        formik.setFieldValue('id', 0)
        formik.values.type = props.data.status === 'base' ? 'base' : 'template'
        formik.setFieldValue('template', '')
        formik.setFieldValue('template_advanced', 0)
        formik.setFieldValue('template_design', null)
        formik.setFieldValue('template_html', null)
        formik.setFieldValue('title', '')
        formik.setFieldValue('method', 'email')

        formik.handleReset()
        setReload(!isReload)
    }

    useEffect(() => {
        resetFrom()
        if (props.data.id) {
            let payload = {
                searchterm: '',
                page: 1,
                limit: 20,
                order: '',
                orderby: '',
                email: '',
                filters: {
                    template: { value: props.data.id, type: 'in', field: 'id' },
                },
            }
            setIsLoading(true)
            getCampaignTemplates(payload, 'GET_CAMPAIGN_SINGLE_TEMPLATES')
        }
    }, [props.data])

    useEffect(() => {
        if (all_templates.records && all_templates.records.length) {
            if (all_templates.from === 'GET_CAMPAIGN_SINGLE_TEMPLATES') {
                formik.setFieldValue(
                    'id',
                    props.data.status === 'new'
                        ? 0
                        : all_templates.records[0].id
                )
                formik.values.type =
                    props.data.status === 'base' ? 'base' : 'template'
                formik.setFieldValue(
                    'template_advanced',
                    all_templates.records[0].template_advanced
                )
                formik.setFieldValue(
                    'template',
                    all_templates.records[0].template
                )
                formik.setFieldValue(
                    'template_design',
                    all_templates.records[0].template_design
                        ? JSON.parse(all_templates.records[0].template_design)
                        : null
                )
                formik.setFieldValue(
                    'template_html',
                    all_templates.records[0].template_html
                )
                formik.setFieldValue('title', all_templates.records[0].title)
                formik.setFieldValue('method', 'email')
                formik.setFieldValue('template_type', 'advanced')
                setReloadEditor(!reloadEditor)
                setReload(!isReload)
            }
            setIsLoading(false)
        }

        // setTimeout(() => {
        //     setIsLoading(false)
        // }, 1000)
    }, [all_templates])

    useEffect(() => {
        if (formik.values.template_advanced) {
            setReloadEditor(!reloadEditor)
        }
    }, [formik.values.template_advanced])

    return (
        <FullScreenPopup
            modaltitle={
                props.data.status === 'new'
                    ? 'ADD NEW TEMPLATE'
                    : `EDIT TEMPLATE: ${''}`
            }
            open={props.data.popup}
            handleClose={() => props.function(false)}
            disableEnforceFocus={true}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        {isLoading ? (
                            <div>Loading....</div>
                        ) : (
                            <>
                                <div className="row">
                                    {Object.values(
                                        mapData({
                                            formik: formik,
                                            data: emailTemplate,
                                        })
                                    )}
                                </div>
                                <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                    <SecondaryButton
                                        id="communicationForm_Cancel"
                                        label="Cancel"
                                        onClick={() => props.function(false)}
                                    />
                                    <PrimaryButton
                                        id="communication_submit"
                                        type="submit"
                                        label="Submit"
                                    />
                                </div>
                            </>
                        )}
                    </form>
                    {/* <EmailEditor /> */}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default TemplateManage
